import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.667 2.667V6h.388m10.237 1.334A5.334 5.334 0 0 0 3.055 6m0 0H6m7.334 7.334V10h-.388m0 0A5.335 5.335 0 0 1 2.708 8.667M12.946 10H10",
      stroke: "#000",
      "stroke-opacity": ".87",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }